import { webKnots } from '../../../../common/back/lace/webKnots'
import { topSidePartOfWebForPicher } from './parts/sideParts'

export const w2Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfIndexFinger(ctx, webColor, laceColor, 3, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -24, 90)
  jointOfIndexFinger(ctx, webColor, laceColor, -45, 160)
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56)
  jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30)
  jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
  ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // バスケットのデザインここから
  ctx.beginPath()
  ctx.moveTo(562, 120) // 左上
  ctx.quadraticCurveTo(534, 166, 509, 237) // 左下
  ctx.quadraticCurveTo(520, 253, 520, 253) // 右下
  ctx.moveTo(562, 120) // 左上
  ctx.quadraticCurveTo(634, 172, 667, 254) // 左上
  ctx.quadraticCurveTo(652, 267, 652, 267) // 左下
  // 区切りライン 横方向
  ctx.moveTo(550, 140) // 左上
  ctx.quadraticCurveTo(613, 190, 652, 267) // 左下
  ctx.moveTo(540, 160) // 左上
  ctx.quadraticCurveTo(595, 205, 623, 258) // 左下
  ctx.moveTo(530, 184) // 左上
  ctx.quadraticCurveTo(576, 227, 588, 251) // 左下
  ctx.moveTo(519, 212) // 左上
  ctx.quadraticCurveTo(538, 226, 553, 248) // 左下
  ctx.stroke()

  // 区切りライン 縦方向
  ctx.moveTo(590, 143) // 上
  ctx.quadraticCurveTo(520, 254, 520, 254) // 下
  ctx.moveTo(614, 168) // 上
  ctx.quadraticCurveTo(553, 248, 553, 248) // 下
  ctx.moveTo(638, 198) // 上
  ctx.quadraticCurveTo(589, 250, 589, 250) // 下
  ctx.moveTo(655, 228) // 上
  ctx.quadraticCurveTo(623, 257, 623, 257) // 下
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 486, 252) // 左下
  ctx.quadraticCurveTo(505, 318, 581, 358) // 右下
  ctx.quadraticCurveTo(630, 326, 689, 277) //
  // バスケットの周り
  // 内側
  ctx.moveTo(560, 113) //左上
  ctx.quadraticCurveTo(529, 172, 500, 243) // 左下1
  ctx.quadraticCurveTo(518, 265, 518, 265) // 左下2
  ctx.quadraticCurveTo(643, 282, 643, 282) // 右下
  ctx.quadraticCurveTo(672, 254, 672, 254) // 右上
  ctx.quadraticCurveTo(635, 161, 560, 113) // 左上
  // 外側
  ctx.moveTo(558, 107) //左上
  ctx.quadraticCurveTo(527, 172, 496, 243) // 左下
  ctx.quadraticCurveTo(518, 270, 518, 270) // 左下2
  ctx.quadraticCurveTo(645, 285, 645, 285) // 右下
  ctx.quadraticCurveTo(677, 256, 677, 256) // 右上
  ctx.quadraticCurveTo(635, 155, 558, 107) // 左上
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目
}

// 左Y軸用
const jointOfIndexFinger = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, x: number, y: number) => {
  // 指袋とウェブのジョイント
  ctx.beginPath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  ctx.moveTo(510 + x, 86 + y) // 左下_1
  ctx.quadraticCurveTo(512 + x, 90 + y, 514 + x, 84 + y) // 左下内
  ctx.quadraticCurveTo(513 + x, 80 + y, 513 + x, 80 + y) // 左内
  ctx.quadraticCurveTo(524 + x, 75 + y, 527 + x, 88 + y) // 右下内
  ctx.quadraticCurveTo(530 + x, 88 + y, 528 + x, 88 + y) // 右下外
  ctx.quadraticCurveTo(534 + x, 82 + y, 545 + x, 54 + y) // 右上
  ctx.quadraticCurveTo(529 + x, 45 + y, 522 + x, 51 + y) // 左上
  ctx.quadraticCurveTo(514 + x, 72 + y, 509 + x, 77 + y) // 左下
  ctx.quadraticCurveTo(510 + x, 86 + y, 510 + x, 86 + y) // 左下_1
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 断面の白色
  ctx.beginPath()
  ctx.lineWidth = 2.0
  ctx.strokeStyle = '#eee'
  ctx.moveTo(512 + x, 87 + y) // 左下
  ctx.quadraticCurveTo(511 + x, 80 + y, 511 + x, 80 + y) // 左上
  ctx.quadraticCurveTo(525 + x, 73 + y, 528 + x, 88 + y) // 右
  ctx.stroke()
  ctx.closePath()
  // lace ここから
  ctx.beginPath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.moveTo(513 + x, 88 + y) // 左下
  ctx.quadraticCurveTo(517 + x, 92 + y, 523 + x, 91 + y) // 右下
  ctx.quadraticCurveTo(527 + x, 87 + y, 523 + x, 83 + y) // 右上
  ctx.quadraticCurveTo(518 + x, 78 + y, 514 + x, 82 + y) // 左上
  ctx.quadraticCurveTo(513 + x, 88 + y, 513 + x, 88 + y) // 左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 側面ライン
  ctx.beginPath()
  ctx.lineWidth = 1.1
  ctx.strokeStyle = '#282828'
  ctx.moveTo(521 + x, 90 + y) // 下
  ctx.quadraticCurveTo(522 + x, 82 + y, 524 + x, 84 + y) // 上
  ctx.stroke()
  ctx.fillStyle = webColor
  ctx.closePath()
}

const jointOfCatchFace = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, x: number, y: number) => {
  // 指袋とウェブのジョイント
  ctx.beginPath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  ctx.moveTo(486 + x, 281 + y) // 左下
  ctx.quadraticCurveTo(515 + x, 315 + y, 515 + x, 315 + y) // 右下
  ctx.quadraticCurveTo(525 + x, 315 + y, 531 + x, 301 + y) // 右上
  ctx.quadraticCurveTo(500 + x, 266 + y, 500 + x, 266 + y) // 左上
  ctx.quadraticCurveTo(495 + x, 277 + y, 486 + x, 281 + y) // 左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // laceここから
  ctx.beginPath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.moveTo(485 + x, 279 + y) // 左下
  ctx.quadraticCurveTo(491 + x, 279 + y, 495 + x, 272 + y) // 右下
  ctx.quadraticCurveTo(490 + x, 268 + y, 486 + x, 272 + y) // 左上
  ctx.quadraticCurveTo(485 + x, 279 + y, 485 + x, 279 + y) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

const jointOfThumbFinger2 = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, x: number, y: number) => {
  // 指袋とウェブのジョイント
  ctx.beginPath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  ctx.moveTo(609 + x, 370 + y) // 左下
  ctx.quadraticCurveTo(628 + x, 370 + y, 638 + x, 353 + y) // 右下
  ctx.quadraticCurveTo(641 + x, 345 + y, 635 + x, 340 + y) // 右上
  ctx.quadraticCurveTo(626 + x, 347 + y, 609 + x, 355 + y) // 左上
  ctx.quadraticCurveTo(610 + x, 352 + y, 609 + x, 370 + y) // 左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 断面ここから
  ctx.beginPath()
  ctx.lineWidth = 2.0
  ctx.strokeStyle = '#eee'
  ctx.moveTo(612 + x, 358 + y) // 左
  ctx.quadraticCurveTo(615 + x, 355 + y, 612 + x, 368 + y) // 右下
  ctx.stroke()
  ctx.strokeStyle = '#282828'
  ctx.closePath()
  // laceここから
  ctx.beginPath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.moveTo(598 + x, 366 + y) //左下
  ctx.quadraticCurveTo(607 + x, 369 + y, 611 + x, 365 + y) // 右下
  ctx.quadraticCurveTo(613 + x, 359 + y, 608 + x, 359 + y) // 右上
  ctx.quadraticCurveTo(601 + x, 358 + y, 601 + x, 358 + y) // 左上
  ctx.quadraticCurveTo(597 + x, 361 + y, 598 + x, 366 + y) // 左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
